import { useEffect } from "react";

// Simple SEO helper — updates document title and meta description
export function useSeo({ title, description, canonicalPath }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    if (canonicalPath) {
      let l = document.querySelector('link[rel="canonical"]');
      if (!l) {
        l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        document.head.appendChild(l);
      }
      const origin = window.location.origin;
      l.setAttribute("href", origin + canonicalPath);
    }
  }, [title, description, canonicalPath]);
}
